import type { CurrencyCode } from '@noths/polaris-client-localisation';

import type { DeliveryZone } from 'src/redux/delivery/types';
import type { DeliverySettingsAPIDeliveryZone } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryZone';

export const adaptDeliverySettingsToStore = (
  deliveryZoneOptions: DeliverySettingsAPIDeliveryZone[],
  userCurrencyCode: CurrencyCode,
): DeliveryZone[] => {
  return deliveryZoneOptions.map((zone) => {
    return {
      zoneCode: zone.zoneCode,
      deliveryOptions: zone.deliveryOptions.map((option) => {
        const {
          deliveryProvider,
          expressShippingPromotion,
          freePartnerShipping,
          prices,
          productCodes,
          ...restOfOption
        } = option;
        const userCurrencyPrice = prices.find((price) => price.currencyCode === userCurrencyCode)!;

        return {
          ...restOfOption,
          partnerFreeDeliveryThresholdPrice:
            freePartnerShipping?.thresholdPrices?.find(
              (price) => price.currencyCode === userCurrencyCode,
            ) ?? null,
          ...(restOfOption.optionCode === 'EXPRESS_24' &&
            expressShippingPromotion && {
              preSalePrice: expressShippingPromotion.originalDeliveryOption.prices.find(
                (price) => price.currencyCode === userCurrencyCode,
              ),
            }),
          price: userCurrencyPrice,
          providerName: deliveryProvider?.name || null,
        };
      }),
      exceptional: zone.exceptional,
      groupingCode: zone.groupingCode,
    };
  });
};
